import { render, staticRenderFns } from "./DocsTab.vue?vue&type=template&id=1d596d1e&"
import script from "./DocsTab.vue?vue&type=script&lang=js&"
export * from "./DocsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports